import React, { useState } from 'react';
import { Menu, Affix, Button, Drawer } from 'antd';
import { Link } from 'react-scroll';
import { Link as RouterLink } from 'react-router-dom';
import { MenuOutlined } from '@ant-design/icons';
import { Trans } from "@lingui/react";
import '../../../styles/header.scss';
import i18n from "../../../locals/i18n.js";
import BookingModal from '../../modals/BookingModal.js';
import { $host } from '../../../http/index.js';

let filename;
switch (i18n.locale) {
    case "am":
        filename = "pricelistam.pdf";
        break;
    case "en":
        filename = "pricelisten.pdf";
        break;
    case "ru":
        filename = "pricelistru.pdf";
        break;
    default:
        filename = "pricelistam.pdf";
}
const linkTo = $host.defaults.baseURL + `pricelists/${filename}`;
const changeLanguage = (lng) => {
    i18n.activate(lng);
    localStorage.setItem("lang", lng);
    window.location.reload();
};

const Header = () => {
    const [menuVisible, setMenuVisible] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);
    return (
        <Affix offsetTop={0}>
            <header className="header">
                <div className="logo">
                    <img src="/assets/logo.png" alt="Company Logo" />
                    {/* <div className='hcf-name'><Trans id="avagClinic" /></div> */}
                </div>

                {/* Hamburger Icon */}
                <Button className="menu-toggle" onClick={() => setMenuVisible(true)}>
                    <MenuOutlined />
                </Button>

                {/* Mobile Drawer */}
                <Drawer
                    title="Menu"
                    placement="right"
                    onClose={() => setMenuVisible(false)}
                    visible={menuVisible}
                    width={250} // Set a reasonable width
                >
                    <Menu mode="vertical" theme="light">
                        {/* <Menu.Item key="home">
                            <RouterLink to="/history" spy={true} smooth={true} duration={500}>
                                <Trans id="home" />
                            </RouterLink>
                        </Menu.Item> */}
                        <Menu.Item key="about">
                            <Link to="about" spy={true} smooth={true} duration={500}>
                                <Trans id="about" />
                            </Link>
                        </Menu.Item>
                        <Menu.Item key="doctors">
                            <Link to="doctors" spy={true} smooth={true} duration={500}>
                                <Trans id="team" />
                            </Link>
                        </Menu.Item>
                        <Menu.Item key="services">
                            <Link to="services" spy={true} smooth={true} duration={500}>
                                <Trans id="services" />
                            </Link>
                        </Menu.Item>
                        <Menu.Item key="prices">
                            <a
                                href={linkTo}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="footer-link"
                            >
                                <Trans id="viewPrices" />
                            </a>
                        </Menu.Item>
                        <Menu.Item key="contact">
                            <Link to="contact" spy={true} smooth={true} duration={500}>
                                <Trans id="contacts" />
                            </Link>
                        </Menu.Item>

                        {/* Languages Dropdown */}
                        <Menu.SubMenu key="languages" title="Languages">
                            <Menu.Item key="arm" onClick={() => changeLanguage("am")}>
                                <img src="/assets/am.svg" alt="ARM Flag" style={{ width: '20px', marginRight: '8px' }} />
                                ARM
                            </Menu.Item>
                            <Menu.Item key="en" onClick={() => changeLanguage("en")}>
                                <img src="/assets/us.svg" alt="EN Flag" style={{ width: '20px', marginRight: '8px' }} />
                                EN
                            </Menu.Item>
                            <Menu.Item key="ru" onClick={() => changeLanguage("ru")}>
                                <img src="/assets/ru.svg" alt="RU Flag" style={{ width: '20px', marginRight: '8px' }} />
                                RU
                            </Menu.Item>
                        </Menu.SubMenu>
                    </Menu>
                </Drawer>

                {/* Desktop Menu (Only visible on large screens) */}
                <Menu mode="horizontal" theme="light" className="menu">
                    {/* <Menu.Item key="home">
                        <RouterLink to="/history" spy={true} smooth={true} duration={500}>
                            <Trans id="home" />
                        </RouterLink>
                    </Menu.Item> */}
                    <Menu.Item key="about">
                        <RouterLink to="/about" spy={true} smooth={true} duration={500}>
                            <Link to="about" spy={true} smooth={true} duration={500}> <Trans id="about" /></Link>
                        </RouterLink>
                    </Menu.Item>
                    <Menu.Item key="doctors">
                        <Link to="doctor" spy={true} smooth={true} duration={500}>
                            <Trans id="team" />
                        </Link>
                    </Menu.Item>
                    <Menu.Item key="services">
                        <Link to="services" spy={true} smooth={true} duration={500}>
                            <Trans id="services" />
                        </Link>
                    </Menu.Item>
                    <Menu.Item key="prices">
                        <a
                            href={linkTo}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="footer-link"
                        >
                            <Trans id="viewPrices" />
                        </a>
                    </Menu.Item>
                    <Menu.Item key="contact">
                        <Link to="contact" spy={true} smooth={true} duration={500}>
                            <Trans id="contacts" />
                        </Link>
                    </Menu.Item>

                    {/* Desktop Languages Dropdown */}
                    <Menu.SubMenu key="languages" title={<Trans id="languages" />} className="ant-menu-item">
                        <Menu.Item key="arm" onClick={() => changeLanguage("am")}>
                            <img src="/assets/am.svg" alt="ARM Flag" style={{ width: '20px', marginRight: '8px' }} />
                            ARM
                        </Menu.Item>
                        <Menu.Item key="en" onClick={() => changeLanguage("en")}>
                            <img src="/assets/us.svg" alt="EN Flag" style={{ width: '20px', marginRight: '8px' }} />
                            EN
                        </Menu.Item>
                        <Menu.Item key="ru" onClick={() => changeLanguage("ru")}>
                            <img src="/assets/ru.svg" alt="RU Flag" style={{ width: '20px', marginRight: '8px' }} />
                            RU
                        </Menu.Item>
                    </Menu.SubMenu>
                </Menu>
                <Button className='booking' onClick={openModal}><Trans id="bookAnAppointment" /></Button>
                <BookingModal
                    isModalOpen={isModalOpen}
                    onClose={closeModal}
                />

            </header>
        </Affix>
    );
};

export default Header;
